// removed by extract-text-webpack-plugin
module.exports = {"footerLinks":"Footer__footerLinks___1JnZ-","link":"Footer__link___3lKeZ"};


//////////////////
// WEBPACK FOOTER
// ./src/root/Footer.scss
// module id = 1268
// module chunks = 0